module.exports = __webpack_public_path__ + "img/pt-br.c73f3f34.jpg";